import React, { Component } from "react";
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { Row, Col, Form, FormTextarea, Button } from "shards-react";
import Modal from 'react-bootstrap/Modal'

import { practiceListActions, getCurrentPracticeList } from "../../core/practice-lists";

import LoadingIndicator from '../common/loading-indicator'

const defaultValidations = new Map({
    motive: {
        required: true,
        valid: false,
        invalid: false,
    }
})

class PracticeModalReject extends Component {
    constructor(props) {
        super(props)

        this.state = {
            validations: defaultValidations.toJS(),
            disabled: false,
            updatePractices: false
        }

        this.handleValidation = this.handleValidation.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleReset = this.handleReset.bind(this);

    }

    handleChange(key,event) {

        const { [key]: _value } = this.state
        const value = (event.target.validity.valid) ? event.target.value : _value;
    
        if ( value !== _value ) {
          this.setState({
              [key]: value
          });

          if( value !== '') {
                this.setState({
                    disabled: false
                });
            }
        }
      }

    handleValidation(key, value) {
        const { validations } = this.state

        let validation = validations[key];

        validation.message = "";

        if (validation.required && !value) {

            validation.valid = false;
            validation.invalid = true;
            validation.message = "El campo es obligatorio.";
            this.setState({
                disabled: true
            });
        } else {
            validation.valid = true;
            validation.invalid = false;
            this.setState({
                disabled: false
            });
        }

        const _validations = Object.assign(validations, {
            [key]: validation
        })

        this.setState({
            validations: _validations,
        });

        return validation;
    }

    validateForm() {
        let error_list = [];

        let result = this.handleValidation('motive', this.state.motive)

        if (!result.valid) {
            error_list.push("motive");
        }

        result = true;
        if (error_list.length) {
            result = false;
        }

        this.setState({
            disabled: !result
        })

        return result;
    }

    handleReject() {
        if ( this.validateForm() ){
            this.props.rejectPractice(this.props.practice_id, this.state.motive)
            this.setState({updatePractices: true})

            this.handleReset()
            this.props.handleClose()
        }
    }

    handleBlur(key,event) {
        this.handleValidation(key, event.target.value)
    }

    handleClose() {
        this.handleReset()
        this.props.handleClose()
    }

    handleReset() {
        this.setState({
            validations: defaultValidations.toJS(),
            disabled: false,
            motive: ''
        });
    }

    render() {
        const { validations, disabled } = this.state
        const { show } = this.props

        return (
            <Modal
                dialogClassName="modal-md"
                show={show}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                style={{ zIndex: 2500 }}
                onHide={() => this.handleClose()}
            >
                <Modal.Header closeButton>
                    <h5 className="m-0">
                        Rechazar Práctica
                    </h5>
                </Modal.Header>
                <Modal.Body className="pt-3">
                    <Row>
                        <Col>
                            <Form>
                                <div className="form-row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label htmlFor="userBio" className="mb-1">Motivo</label>
                                            <FormTextarea defaultValue='' id="motive" name="motive" onBlur={this.handleBlur.bind(this, 'motive')} onChange={this.handleChange.bind(this, 'motive')} required invalid={validations.motive.invalid} valid={validations.motive.valid} />
                                            <div className="invalid-feedback">{validations.motive.message}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-right">
                                    <Button disabled={disabled} onClick={e => { if(window.confirm('¿Seguro desea rechazar la práctica? Esta operación es irreversible.')) this.handleReject() }} className="ml-auto btn-accent btn-sm m-1">Rechazar</Button>
                                    <Button onClick={e => this.handleClose()} className="btn-sm">Cancelar</Button>
                                </div>
                            </Form>
                            
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }
}

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {

const practicelist = getCurrentPracticeList(state, props)
  let isPending = true;
  if (practicelist)
    isPending = practicelist.isPending
   return {
        user: state.session.user,
        practicelist_pending: isPending
   }
  };
  
  const mapDispatchToProps = {
    loadPractices: practiceListActions.loadPractices,
    rejectPractice: practiceListActions.rejectPractice,
  };
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(PracticeModalReject);
  